import { linkedPackage } from 'lincd/utils/Package';
export const { linkedComponent, linkedShape, linkedUtil, linkedOntology, registerPackageExport, packageExports, } = linkedPackage('lincd-xsd');
//# sourceMappingURL=package.js.map